import { Explore } from '@mui/icons-material'
import T from 'i18n-react'
import React, { useEffect, Fragment} from 'react';
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ClientActions from '../../store/clientRedux'
import ContentPlain from '../../components/layout/ContentPlain';
import FilingStatusCard from './components/filingStatusCard'
import RefilingStatusCard from './components/refilingtatusCard'
import AssociatedReturnCard from './components/associatedReturnCard'
import Section from '../../components/layout/Section'
import BackLink from '../../components/library/common/BackLink';
import SkeletonFilingStatusCard from './components/SkeletonFilingStatusCard';
import StackableCardWrapper from '../../components/library/stacking-collapsible-cards/StackableCardWrapper';
import Skeleton from '../../components/library/loaders/Skeleton';
import './DiyFiledReturnPage.scss'

const DiyFiledReturnPage = () => {
    const { vmId, id, taxYear } = useParams();
    const client = useSelector(state => state.client)
    const clientReturns = useSelector(state => state.client.returns)
    const associatedReturn = useSelector(state => state.client.associatedReturnId)
    const searchingReturns = useSelector(state => state.client.searchingReturns)
    const searchingAssociatedReturn = useSelector(state => state.client.searchingAssociatedReturn)

    const dispatch = useDispatch();

    useEffect(() => {
        const returnId = id || vmId
        document.getElementById('overflow-container').scrollTo({ top: 0, behavior: 'smooth' });
        if (returnId && taxYear && taxYear !== 'undefined') {
            dispatch(ClientActions.searchReturns(returnId, taxYear, !!vmId))
        }
    }, [id, vmId, taxYear]);

    const renderNoResults = () => {
        let failedSearchCriteria = !!vmId ? `VMID-${vmId}-${taxYear}` : `ID-${id}-${taxYear}`

        return (
            <Fragment>
                <Section sectionId='section-return-header'>
                    <ContentPlain elementId='diyFiledReturnHeader'>
                        <div className='columns'>
                            <div className='column is-2 is-offset-9'>
                                <BackLink isRight />
                            </div>
                        </div>
                    </ContentPlain>
                </Section>
                <Section sectionId='section-return-details' className='light-functional-grey'>
                    <ContentPlain elementId='no-filed-results'>
                        <div className='noClientsBox analyst-no-results-box'>
                            <div></div>
                            <div className='analyst-no-results-box-orientation'>
                                <div className='analyst-no-results-box-display'>
                                    <div></div>
                                    <div><Explore className='analyst-no-results-explore' /></div>
                                    <div></div>
                                </div>
                                <div className='analyst-no-results-font'><p>{T.translate('ClientLookup.NotFound.CouldntFind')}<b>{failedSearchCriteria}</b></p></div>
                            </div>
                            <div></div>
                        </div>
                    </ContentPlain>
                </Section>
            </Fragment>)
    }

    const renderResults = () => {
        var formattedTaxYear = `20${taxYear}`;
        var returnId = Number(clientReturns[0].returnid);

        var fileContext = clientReturns[0].filecontext
        var allEqual = true

        for (var i = 0; i < clientReturns.length; i++) {
            if (i > 0) {
                if (clientReturns[0].returnid !== clientReturns[i].returnid) {
                    allEqual = false;
                    break;
                }
            }
        }

        return (<Fragment>
            <Section sectionId='section-return-header'>
                <ContentPlain elementId='diyFiledReturnHeader'>
                    <div className='columns'>
                        <div className='column is-8 is-offset-1'>
                            <h1>{formattedTaxYear} | {T.translate('ReturnStatus.Title')} {returnId}</h1>
                        </div>
                        <div className='column is-2'>
                            <BackLink isRight />
                        </div>
                    </div>
                </ContentPlain>
            </Section>
            <Section sectionId='section-return-details' className='light-functional-grey'>
                <ContentPlain elementId='diyFiledReturnContent'>
                    <StackableCardWrapper>
                        {allEqual ? <FilingStatusCard type={fileContext} returns={clientReturns} /> : <RefilingStatusCard type={fileContext} id={fileContext} returnStatii={clientReturns} expandedReturnId={id} />}
                    </StackableCardWrapper>
                    <div className='analyst-card-vertical-spacer' />
                    <AssociatedReturnCard taxYear={taxYear} loading={searchingAssociatedReturn} fileContext={fileContext} associatedReturnId={associatedReturn} isCollapsed={false} />
                </ContentPlain>
            </Section>
        </Fragment>)
    }

    return (
        <div className='content-grid product-info-page'>
            {searchingReturns === true || !client ?
                <Fragment>
                    <Section sectionId='section-return-header'>
                        <ContentPlain elementId='diyFiledReturnHeader'>
                            <div className='columns'>
                                <div className='column is-8 is-offset-1'>
                                    <Skeleton />
                                </div>
                                <div className='column is-2'>
                                    <BackLink isRight />
                                </div>
                            </div>
                        </ContentPlain>
                    </Section>
                    <Section sectionId='section-return-details' className='light-functional-grey'>
                        <ContentPlain>
                            <SkeletonFilingStatusCard />
                        </ContentPlain>
                        <div />
                    </Section>
                </Fragment> :
                clientReturns && clientReturns.length > 0 ? renderResults() : renderNoResults()
            }
        </div>)
}

export default DiyFiledReturnPage